<template>
  <div class="smain">
    sadasdasd
  </div>
</template>

<script>
export default {}
</script>

<style>
.smain {
  height: 560px;
  width: 100%;
  background-image: url('../../assets/img_body_bg.png');
  margin-top: 43px;
}
</style>
